import { cn } from '@/shared/lib/cn';

interface SubscriptionIconProps {
  letter: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-[30px] h-[30px] rounded-[8px] text-sm',
  md: 'w-[34px] h-[34px] rounded-[10px] text-base',
  lg: 'w-[44px] h-[44px] rounded-[12px] text-xl',
};

export function SubscriptionIcon({ letter, size = 'sm', className }: SubscriptionIconProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center flex-shrink-0',
        'bg-brand-gradient text-white font-bold',
        'shadow-[0_3px_8px_rgba(18,120,90,0.28)]',
        sizeClasses[size],
        className,
      )}
    >
      {letter.charAt(0).toUpperCase()}
    </span>
  );
}
